var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSubmit)?_c('button',{class:_vm.ui ? 'btn__' + _vm.ui : 'btn__primary',attrs:{"formData.action":"/submit","type":_vm.type},on:{"click":_vm.btnClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('div',{class:_vm.ui ? 'btn__' + _vm.ui : 'btn__primary',on:{"click":_vm.btnClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }